import classNames from 'classnames'
import styles from './AmountField.module.css'
import { AmountFieldProps } from './types'
import { TextInput } from '../TextInput'
import { forwardRef } from 'react'

const AmountField = forwardRef<HTMLInputElement, AmountFieldProps>(
  ({ label, name, id, min, hideSteps = false, className, children, ...props }, ref) => {
    return (
      <TextInput
        {...props}
        ref={ref}
        id={id || name}
        name={name}
        label={label}
        type="number"
        inputMode="decimal"
        min={min ?? 0}
        className={classNames(className, { [styles.hideSteps!]: hideSteps })}
      >
        {children}
      </TextInput>
    )
  }
)

AmountField.displayName = 'AmountField'

export default AmountField
